import React from 'react'
import './styles.scss'
import '../../styles/index.scss'

export default ({ children }) => (
  <div
    data-automation-name='FAA'
    className='page homepage'
  >
    <div className='content-body'>
      <div id='main-container'>
        <div id='form' className='block'>
          <div className='container'>
            <h1 className='first' data-automation-name='header1'>Patient Financial Assistance Application</h1>
            <div className='col-lg-8 col-lg-offset-2'>
              <div className='row'>
                <div className='col-lg-12'>
                  <p className='text-center' data-automation-name='header2'>
                    Our financial assistance program provides patients with the opportunity for comprehensive genomic profiling, regardless of financial status.
                  </p>
                </div>
              </div>
              <p className='text-center' data-automation-name='header3'>
                Financial assistance is available for patients whose tests are performed by Foundation Medicine, Inc. and were ordered within the U.S. and U.S. territories.
              </p>
              {children}
            </div>
          </div>
          <div className='background-polygon' />
        </div>
      </div>
    </div>
  </div>
)
